module.exports = __webpack_public_path__ + "img/normal_icon_04.c463b74.png";